export const PRODUCT_TTL_ES = 'Productos';

export interface IProductBase {
  itemId: number;
  laboratoryId: number;
  unitMeasureId: number;
}
export interface IProduct {
  id: number;
  activesIngredients: string;
  itemCode: string;
  itemId: number;
  itemName: string;
  laboratoryDescription: string;
  laboratoryId: number;
  therapistGroups: string;
  unitMeasureDescription: string;
  unitMeasureId: number;
  unitMeasureSymbol: string;
}
